import { MantineThemeOverride } from '@mantine/core';

export type SliderTheme = NonNullable<MantineThemeOverride['components']>['Slider'];

export const Slider: SliderTheme = {
  // todo: define
};
